export const LOCAL_STORAGE_KEYS = Object.freeze({
  SOURCE_CHECK_DOCUMENT_APPEARANCE: 'siq-source-check-document-appearance',
});
